import { timeDistance } from '@/utils/convert';

export const entity = [
    // {
    //     label: '№ п/п',
    //     key: 'number',
    //     convert: (item, i) => i + 1,
    // },
    {
        label: 'ID осмотра',
        key: 'inspectionId',
    },
    {
        label: 'Комментарий',
        key: 'medicComment',
    },
    {
        label: 'ФИО',
        key: 'employeeFIO',
    },
    {
        label: 'Дата рождения',
        key: 'employeeBirthday',
        convert: (item) => item.employeeBirthday ? new Date(item.employeeBirthday).toLocaleDateString() : '-',
    },
    {
        label: 'Пол',
        key: 'employeeGender',
        convert: (item) => {
            if (item.employeeGender === null) {
                return '-'
            }
            return item.employeeGender ? 'Мужской' : 'Женский';
        }
    },
    {
        label: 'Табельный №',
        key: 'employeepersonNumber',
    },
    {
        label: 'Телефон',
        key: 'employeePhone',
    },
    {
        label: 'Организация',
        key: 'orgName',
    },
    {
        label: 'Жалобы',
        key: 'complaints',
    },
    {
        label: 'Артериальное давление',
        key: 'pressure',
        convert: item => `${item.pressureSys ?? '-'} / ${item.pressureDia ?? '-'}`
    },
    {
        label: 'Пульс',
        key: 'pressurePulse',
    },
    {
        label: 'Температура',
        key: 'temperatureValue',
    },
    {
        label: 'Алкоголь',
        key: 'alcoholValue',
    },
    {
        label: 'Длительность',
        key: 'inspectionType',
        convert: (item) => {
            return timeDistance(item.videoEndDate || item.canceledDate, item.videoStartDate)
        }
    },
    {
        label: 'Дата осмотра',
        key: 'inspectionTypeDate',
        convert: (item) => item.inspectionTypeDate ? new Date(item.inspectionTypeDate).toLocaleString() : '-',
    },
    {
        label: 'Точка выпуска',
        key: 'point',
    },
    {
        label: 'ПАК',
        key: 'license',
    },
    {
        label: 'Ссылка на видео',
        key: 'videoS3Key',
    },
];